import { render, staticRenderFns } from "./RegistrationNumberInput.vue?vue&type=template&id=5a9c4602&"
import script from "./RegistrationNumberInput.vue?vue&type=script&lang=ts&"
export * from "./RegistrationNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports